// extracted by mini-css-extract-plugin
export default {"container":"maroon_container__KH3ug","font":"maroon_font__lMq1G","borderBottom":"maroon_borderBottom__WLKqN","borderTop":"maroon_borderTop__NXa9i","button":"maroon_button__jydOl"};